import { Typography } from '@smartgift/frontend-toolkit';
import React from 'react';

import * as S from './style';

function EmptySection({ title, ...props }) {
  return (
    <S.EmptySectionWrapper {...props}>
      <Typography variant="body2" emphasis="weaker">
        {title}
      </Typography>
    </S.EmptySectionWrapper>
  );
}

export { EmptySection };
